import { type Discoverability, type DiscoverabilityInput } from "../../gql-generated/types";

export const makeLensDiscoverabilityInput = (discoverability: Discoverability | null): DiscoverabilityInput => {
    return {
        description: discoverability?.description ?? "",
        tagsList: [...(discoverability?.tagsList ?? [])],
        locationsList: [...(discoverability?.locationsList ?? [])],
        daysTimesHolidaysList: [...(discoverability?.daysTimesHolidaysList ?? [])],
    };
};
